export interface Character {
  id: number;
  name: string;
  role: string;
  tags: string[];
  desc: string;
  image: string;
}

export interface Article {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  date: string;
  read: string;
  image: string;
}

export interface Discussion {
  id: number;
  user: string;
  avatar: string;
  content: string;
  time: string;
  likes: string;
  replies: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface RankItem {
  rank: number;
  title: string;
  heat: string;
  trend: 'up' | 'down' | 'flat';
  tag: string;
}

export const heroImage =
  'https://readdy.ai/api/search-image?query=vibrant%20comic%20book%20style%20illustration%20collage%20with%20dynamic%20action%20panels%2C%20warm%20coral%20red%20and%20golden%20amber%20color%20palette%2C%20energetic%20ink%20brush%20textures%2C%20dramatic%20lighting%2C%20speech%20bubbles%20and%20halftone%20dots%2C%20graphic%20novel%20aesthetic%2C%20rich%20layered%20composition&width=1600&height=900&seq=hero-heixiu-2026&orientation=landscape';

export const characters: Character[] = [
  {
    id: 1,
    name: '小嘿',
    role: '主角',
    tags: ['热血', '冲动', '成长'],
    desc: '故事的核心人物，从普通少年一路跌撞成长。社区读者最喜欢讨论他的每一次选择背后藏着怎样的伏笔。',
    image:
      'https://readdy.ai/api/search-image?query=young%20anime%20style%20male%20hero%20character%20portrait%2C%20warm%20coral%20and%20amber%20toned%20background%2C%20confident%20expression%2C%20dynamic%20comic%20ink%20linework%2C%20energetic%20brush%20highlights%2C%20clean%20graphic%20illustration&width=640&height=800&seq=char-heixiu-01&orientation=portrait',
  },
  {
    id: 2,
    name: '阿咻',
    role: '青梅竹马',
    tags: ['冷静', '敏锐', '守护'],
    desc: '与主角一同长大的伙伴，总是能在混乱中给出关键提醒。她对角色关系的解读常常引发热烈讨论。',
    image:
      'https://readdy.ai/api/search-image?query=calm%20anime%20style%20young%20woman%20character%20portrait%2C%20warm%20coral%20and%20golden%20amber%20toned%20background%2C%20gentle%20but%20determined%20expression%2C%20comic%20ink%20linework%2C%20clean%20graphic%20illustration&width=640&height=800&seq=char-heixiu-02&orientation=portrait',
  },
  {
    id: 3,
    name: '夜枭',
    role: '神秘反派',
    tags: ['深沉', '谜团', '反转'],
    desc: '贯穿全篇的谜之人物，动机成谜。他的每次登场都被读者逐帧分析，是讨论区当之无愧的热度担当。',
    image:
      'https://readdy.ai/api/search-image?query=mysterious%20anime%20style%20antagonist%20portrait%20in%20dark%20cloak%2C%20warm%20amber%20and%20deep%20charcoal%20background%2C%20intense%20hooded%20eyes%2C%20dramatic%20comic%20ink%20lighting%2C%20graphic%20illustration&width=640&height=800&seq=char-heixiu-03&orientation=portrait',
  },
  {
    id: 4,
    name: '老柴',
    role: '引导者',
    tags: ['亦正亦邪', '经验', '深藏'],
    desc: '身份暧昧的引路人，既像帮手又像棋手。读者对其真实立场的分歧，是社区长盛不衰的话题。',
    image:
      'https://readdy.ai/api/search-image?query=wise%20cunning%20anime%20style%20mentor%20character%20portrait%2C%20warm%20coral%20and%20amber%20background%2C%20knowing%20smile%2C%20comic%20ink%20linework%2C%20clean%20graphic%20illustration&width=640&height=800&seq=char-heixiu-04&orientation=portrait',
  },
  {
    id: 5,
    name: '小辣椒',
    role: '热血后辈',
    tags: ['直率', '勇气', '爆发'],
    desc: '新登场的高人气角色，性格直来直去。她的成长线被不少读者认为是近期最大的亮点。',
    image:
      'https://readdy.ai/api/search-image?query=fiery%20energetic%20anime%20style%20young%20heroine%20portrait%2C%20warm%20coral%20and%20golden%20background%2C%20bold%20smile%2C%20comic%20ink%20linework%2C%20dynamic%20graphic%20illustration&width=640&height=800&seq=char-heixiu-05&orientation=portrait',
  },
  {
    id: 6,
    name: '灰线',
    role: '神秘势力',
    tags: ['势力', '布局', '悬念'],
    desc: '隐藏在故事背后的组织，看似无关却处处插手。关于它的全貌，读者仍在不断拼图。',
    image:
      'https://readdy.ai/api/search-image?query=enigmatic%20anime%20style%20silhouette%20figure%20in%20grey%20coat%2C%20warm%20amber%20and%20charcoal%20background%2C%20hidden%20identity%2C%20moody%20comic%20ink%20lighting%2C%20graphic%20illustration&width=640&height=800&seq=char-heixiu-06&orientation=portrait',
  },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '第一话开场解析：悬念如何被悄悄埋下',
    category: '剧情拆解',
    excerpt: '短短几格画面里其实藏了三处伏笔。我们从构图、台词到动作细节，逐帧还原开场的叙事机关。',
    date: '08-16',
    read: '1.2w',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20comic%20opening%20scene%20illustration%2C%20warm%20coral%20and%20amber%20palette%2C%20close%20up%20of%20character%20with%20mysterious%20background%2C%20ink%20textures%2C%20graphic%20novel%20panel&width=800&height=500&seq=article-heixiu-01&orientation=landscape',
  },
  {
    id: 2,
    title: '主角成长弧光全梳理：从懵懂到觉醒',
    category: '人物专题',
    excerpt: '把主角一路的挣扎、选择与转变按时间线串起来，你会发现每一个低谷都在为后来的爆发蓄力。',
    date: '08-14',
    read: '8.6k',
    image:
      'https://readdy.ai/api/search-image?query=hero%20character%20growth%20journey%20comic%20illustration%2C%20warm%20amber%20and%20coral%20tones%2C%20silhouette%20walking%20through%20changing%20backgrounds%2C%20graphic%20novel%20style&width=800&height=500&seq=article-heixiu-02&orientation=landscape',
  },
  {
    id: 3,
    title: '「转折章」深度拆解：那些被回收的伏笔',
    category: '伏笔回收',
    excerpt: '很多人以为的突然转折，其实早在几十话前就已埋好。这篇把回收路径完整画给你看。',
    date: '08-12',
    read: '9.4k',
    image:
      'https://readdy.ai/api/search-image?query=dramatic%20plot%20twist%20comic%20scene%2C%20warm%20coral%20and%20charcoal%20palette%2C%20explosion%20of%20panels%20and%20halftone%20dots%2C%20graphic%20novel%20illustration&width=800&height=500&seq=article-heixiu-03&orientation=landscape',
  },
  {
    id: 4,
    title: '反派动机的多重解读：他到底在执着什么',
    category: '人物专题',
    excerpt: '关于夜枭的立场，社区里吵了三个月。本文汇总主流观点，并给出更多值得留意的细节线索。',
    date: '08-10',
    read: '1.1w',
    image:
      'https://readdy.ai/api/search-image?query=villain%20motivation%20analysis%20comic%20illustration%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20shadowy%20figure%20in%20center%2C%20moody%20ink%20lighting%2C%20graphic%20novel%20style&width=800&height=500&seq=article-heixiu-04&orientation=landscape',
  },
  {
    id: 5,
    title: '结局前最后十话推演：三条可能的方向',
    category: '结局预测',
    excerpt: '结合已有伏笔与叙事节奏，我们推演出几种结局走向，并标明每条路线可能的证据与矛盾点。',
    date: '08-08',
    read: '1.5w',
    image:
      'https://readdy.ai/api/search-image?query=ending%20prediction%20comic%20concept%2C%20warm%20coral%20and%20golden%20amber%20palette%2C%20three%20diverging%20paths%20visualization%2C%20graphic%20novel%20illustration&width=800&height=500&seq=article-heixiu-05&orientation=landscape',
  },
  {
    id: 6,
    title: '人物关系网图文解说：谁在背后推了谁',
    category: '设定整理',
    excerpt: '一张图看懂主要角色的互动与暗线。理清关系网后，很多剧情疑问都会迎刃而解。',
    date: '08-06',
    read: '7.2k',
    image:
      'https://readdy.ai/api/search-image?query=character%20relationship%20web%20comic%20illustration%2C%20warm%20amber%20and%20coral%20tones%2C%20interconnected%20portraits%20with%20lines%2C%20graphic%20novel%20style&width=800&height=500&seq=article-heixiu-06&orientation=landscape',
  },
];

export const discussions: Discussion[] = [
  {
    id: 1,
    user: '追更到天亮',
    avatar: '#ea5636',
    content: '重刷了第三遍才发现，主角第一话说过的那句话在结局真的有回扣！编剧藏得太深了。',
    time: '2 小时前',
    likes: '2.3k',
    replies: '186',
  },
  {
    id: 2,
    user: '夜枭粉头',
    avatar: '#ed9220',
    content: '有没有人注意到夜枭的斗篷纹样和灰线组织的徽记是同一个图案？这绝对不只是巧合。',
    time: '5 小时前',
    likes: '1.8k',
    replies: '142',
  },
  {
    id: 3,
    user: '一话不落的某人',
    avatar: '#238c74',
    content: '从老柴第一次登场就觉得他不简单，现在看果然处处是伏笔，他的立场反转我真的哭了。',
    time: '昨天',
    likes: '1.1k',
    replies: '97',
  },
  {
    id: 4,
    user: '结局赌徒',
    avatar: '#b4361f',
    content: '我赌结局是开放式，但开放式也有开放式的高级写法，希望别烂尾，稳住啊作者！',
    time: '昨天',
    likes: '986',
    replies: '120',
  },
];

export const faqs: FaqItem[] = [
  {
    q: '嘿咻嘿咻漫画现在更新到哪里了？',
    a: '讨论社区会实时汇总最新章节进度与追更热点，让你快速了解当前故事推进到哪一话，以及最近讨论最热烈的情节。',
  },
  {
    q: '在哪里可以看剧情解析和角色设定？',
    a: '本社区将剧情总览、角色设定、专题解析与结局探讨集中在一个页面中按板块分区呈现，随时回看、随时查阅，无需东翻西找。',
  },
  {
    q: '结局是开放式的吗？',
    a: '结局部分集合了多种主流解读与伏笔盘点，不同读者可以互换观点。究竟是开放式还是另有深意，欢迎理性讨论。',
  },
  {
    q: '可以和别人一起讨论剧情吗？',
    a: '当然可以。社区鼓励读者在讨论区分享自己的解读、预测与疑问，找到同好一起交流，追更不孤单。',
  },
  {
    q: '角色设定资料会更新吗？',
    a: '会。随着剧情推进，新登场角色与设定会持续补充进角色档案，方便大家随时掌握最新的人物关系。',
  },
];

export const ranking: RankItem[] = [
  { rank: 1, title: '夜枭真实身份的三种可能', heat: '12.8k', trend: 'up', tag: '热点' },
  { rank: 2, title: '结局预测集中讨论帖', heat: '9.6k', trend: 'up', tag: '结局' },
  { rank: 3, title: '主角那句台词的回扣分析', heat: '8.1k', trend: 'up', tag: '伏笔' },
  { rank: 4, title: '灰线组织的完整拼图', heat: '5.4k', trend: 'flat', tag: '设定' },
  { rank: 5, title: '老柴立场反转争议帖', heat: '4.7k', trend: 'down', tag: '讨论' },
];